let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lQQ9A")).then(() => parcelRequire('jZvWA'));